import PropTypes from 'prop-types'
import { sliceStatusPropTypes } from '../slice.types'

/**
 * @typedef {Object} CheckoutValidationError
 * @property {string} cart_item_id - Cart item ID with the error
 * @property {number} expected - Expected quantity
 * @property {number} assigned - Actually assigned quantity
 * @property {string} error_type - Type of error ('under_assigned' | 'over_assigned')
 */

/**
 * @typedef {Object} CheckoutSliceState
 * @property {import('../slice.types').SliceStatus} status - General slice status
 * @property {import('../slice.types').SliceError[]} errors - General errors
 * @property {import('../slice.types').SliceStatus} validationStatus - Validation request status
 * @property {CheckoutValidationError[]} validationErrors - Validation errors from backend
 */

/** @type {CheckoutSliceState} */
export const initialCheckoutState = {
  status: 'init',
  errors: [],
  validationStatus: 'init',
  validationErrors: []
}

/** @enum {string} */
export const CHECKOUT_ACTIONS = {
  SET_STATUS: 'CHECKOUT/SET_STATUS',
  SET_ERRORS: 'CHECKOUT/SET_ERRORS',
  CLEAR_ERRORS: 'CHECKOUT/CLEAR_ERRORS',
  SET_VALIDATION_STATUS: 'CHECKOUT/SET_VALIDATION_STATUS',
  SET_VALIDATION_ERRORS: 'CHECKOUT/SET_VALIDATION_ERRORS',
  CLEAR_VALIDATION_ERRORS: 'CHECKOUT/CLEAR_VALIDATION_ERRORS'
}

export const checkoutValidationErrorPropType = PropTypes.shape({
  cart_item_id: PropTypes.string.isRequired,
  expected: PropTypes.number.isRequired,
  assigned: PropTypes.number.isRequired,
  error_type: PropTypes.oneOf(['under_assigned', 'over_assigned']).isRequired
})

export const checkoutSlicePropType = PropTypes.shape({
  status: sliceStatusPropTypes,
  errors: PropTypes.arrayOf(PropTypes.shape({ message: PropTypes.string })),
  validationStatus: sliceStatusPropTypes,
  validationErrors: PropTypes.arrayOf(checkoutValidationErrorPropType)
})
